module.exports = __webpack_public_path__ + "school/img/erweima.f961c928.jpg";